import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 32px;
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-weight: 400;
  line-height: 1;
`;